// Page first, brand last, so search results show the words that matter
// before the ~60-character cut-off. The brand is added only when the whole
// title still fits in 60 characters; past that Google would cut the brand
// anyway. Titles that already name the brand (server titles like
// "Winter coats | Aid Registry") are left alone.
//
// Shared by the browser and SSR entrypoints, and mirrored on the server by
// SeoHead.branded_title: if they disagree, the title flips after hydration.
const TITLE_LIMIT = 60

export function pageTitle(title: string): string {
  if (!title) return 'Aid Registry'
  if (title.includes('Aid Registry')) return title
  const full = `${title} · Aid Registry`
  return full.length <= TITLE_LIMIT ? full : title
}

// A campaign page names its charity ("Coat drive by Hope Shelter") only while
// the title stays within the limit; long campaign titles stand alone.
export function campaignTitle(title: string, orgName?: string | null): string {
  const withOrg = orgName ? `${title} by ${orgName}` : title
  return withOrg.length <= TITLE_LIMIT ? withOrg : title
}

// Charities often type their website without "https://", which a browser
// treats as a path on our own site (/explore/www.example.org, a 404).
export function externalUrl(url: string): string {
  const trimmed = url.trim()
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed.replace(/^\/+/, '')}`
}
